import { action as apiAction } from 'api/Api'
import {
  remove
} from '../redux/cardBlockers'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardBlockerId: number,
  reason?: string
}

const requestRemoveCardBlocker = (payload: Payload) => async dispatch => {
  const { cardBlockerId, reason } = payload

  const optimisticAction = optimisticDispatch(dispatch, remove({
    cardBlockerId,
  }))

  try {
    await apiAction('RemoveBlockerFromCard', {
      id: cardBlockerId,
      reason,
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()
    
    if (
      error.code !== 401 // ElementNotFoundException
    ) {
      throw error
    }
  }
}

export default requestRemoveCardBlocker
